import { NavLink } from 'react-router-dom';
import { memberDetailsRoute } from '@bo-components/navigation/Router';
import { useAuthorizePermissions } from '@bo-hooks/authentication/useAuthorizePermissions';

export const MemberDetailsNavigation = () => {
  const { childRoutes } = memberDetailsRoute;
  const { hasValidPermission } = useAuthorizePermissions();

  return (
    <nav className="p-6" data-testid="member-navigation">
      <ul className="flex gap-4">
        {childRoutes
          ?.filter((route) => hasValidPermission({ route }))
          .map((memberDetailTab) => {
            const { path, title } = memberDetailTab;

            return (
              <li key={title}>
                <NavLink
                  className={({ isActive }) =>
                    [
                      isActive
                        ? 'border-stankonia-100 text-soClean-100 border-b-2 pb-2'
                        : 'text-soClean-180',
                      'capitalize'
                    ].join(' ')
                  }
                  data-testid={title}
                  to={path || title}
                >
                  {title}
                </NavLink>
              </li>
            );
          })}
      </ul>
    </nav>
  );
};
